function subtractFiveHoursThirtyMinutes(date: Date): Date {
    // Convert 5 hours and 30 minutes to milliseconds
    const subtractTime = (5 * 60 * 60 * 1000) + (30 * 60 * 1000);
  
    // Subtract time from the date
    const updatedDate = new Date(date.getTime() - subtractTime);
  
    return updatedDate;
  }


export default subtractFiveHoursThirtyMinutes;  